import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { ChevronCircleButton } from "@portal/components/atoms/buttons/chevronCircle/ChevronCircleButton";
import { SelectionBoxComponent } from "../../../components/selectionBox/SelectionBoxComponent";
import { useRobot } from "@portal/app/context/robotProvider";
import { GetOption } from "../../../sustainability/common/helpers/getOption";
import PortalPageBox from "@portal/components/atoms/portalPageBox";
import { ISustainabilityProps } from "../../../sustainability/common/types";

export const SFDRInfo = ({ isDefaultLanguage }: ISustainabilityProps) => {
  const { riskLevelRequest, setSustainabilitySfdr } = useRobot();
  const [isExpanded, setIsExpanded] = useState(false);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_7_OPTIONS_2_A, texts.PAGE_7_OPTIONS_2_B];
  const OnSelectionClick = (selectedOption: number) => {
    if (selectedOption !== null) {
      setSustainabilitySfdr(selectedOption === 0);
    }
  };
  return (
    <div className="flex flex-col sm:flex-row sm:space-x-3">
      <PortalPageBox className="flex flex-col my-3 sm:w-[60%]">
        <Typography variant="Lead">{texts.PAGE_7_INFO_TEXT_2_HEADER}</Typography>
        <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_2_A}</Typography>
        <div className="flex py-2 justify-center">
          <ChevronCircleButton isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        </div>
        {isExpanded && (
          <>
            <div className="flex mt-2">
              <Typography variant="Bold">{texts.PAGE_7_INFO_TEXT_2_B}</Typography>
            </div>
            <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_2_C}</Typography>
            <div className="flex mt-2">
              <Typography variant="Bold">{texts.PAGE_7_INFO_TEXT_2_D}</Typography>
            </div>
            <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_2_E}</Typography>
            <div className="flex mt-2">
              <Typography variant="Bold">{texts.PAGE_7_INFO_TEXT_2_F}</Typography>
            </div>
            <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_2_G}</Typography>
          </>
        )}
      </PortalPageBox>
      <div className="flex sm:w-[40%] w-full">
        <SelectionBoxComponent
          options={options}
          selectedOption={GetOption(riskLevelRequest.sustainabilitySfdr) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
      </div>
    </div>
  );
};
